import { createRouter, createWebHistory } from 'vue-router'
import ContratosView from '../views/ContratosView.vue'
import HomeView from '../views/HomeView.vue'
import FinanzasView from '../views/FinanzasView.vue'
import MantenimientoView from '../views/MantenimientoView.vue'
import ServiciosView from '../views/ServiciosView.vue'
import CobranzaView from '../views/CobranzaView.vue'
import ConfiguracionView from '../views/ConfiguracionView.vue'
import LoginView from '../views/LoginView.vue'
import PasswordRecoveryView from '../views/PasswordRecoveryView.vue'
import RegistroView from '@/views/RegistroView.vue'
import ActivateAccountView from '../views/ActivateAccountView.vue'
import AccountView from '../views/AccountView.vue'
import TechnicianTicketsView from '../views/TechnicianTicketsView.vue'
import TechnicianTicketDetailView from '../views/TechnicianTicketDetailView.vue'
import TechnicianCalendarView from '../views/TechnicianCalendarView.vue'
import TechnicianScheduledDetailView from '../views/TechnicianScheduledDetailView.vue'
import TenantContractView from '../views/TenantContractView.vue'
import TenantRequestsView from '../views/TenantRequestsView.vue'
import TenantRequestDetailView from '../views/TenantRequestDetailView.vue'
import TenantPaymentsView from '../views/TenantPaymentsView.vue'
import TenantSummaryView from '../views/TenantSummaryView.vue'
import TenantAccountView from '../views/TenantAccountView.vue'
import NotFoundView from '../views/NotFoundView.vue'
import SuperadminLoginView from '../views/SuperadminLoginView.vue'
import SuperadminParksView from '../views/SuperadminParksView.vue'
import SuperadminUsersView from '../views/SuperadminUsersView.vue'
import SuperadminAuditView from '../views/SuperadminAuditView.vue'
import OnboardingView from '../views/OnboardingView.vue'
import SuperadminDashboardView from '../views/SuperadminDashboardView.vue'
import SuperadminSystemView from '../views/SuperadminSystemView.vue'
import SuperadminBillingView from '../views/SuperadminBillingView.vue'
import { useAuthStore } from '../services/authStore'
import { useSuperadminStore } from '../services/superadminStore'
import { userHasPageAccess, PAGE_KEYS } from '../constants/accessControl'

const routes = [
  { path: '/', redirect: '/inicio' },
  { path: '/login', name: 'Login', props: true, component: LoginView, meta: { public: true } },
  { path: '/registro', name: 'Registro', component: RegistroView, meta: { public: true } },
  { path: '/olvide-contrasena', name: 'OlvideContrasena', component: PasswordRecoveryView, meta: { public: true } },
  { path: '/restablecer-contrasena', name: 'RestablecerContrasena', component: PasswordRecoveryView, meta: { public: true } },
  { path: '/activar-cuenta', name: 'ActivarCuenta', props: true, component: ActivateAccountView, meta: { public: true } },
  { path: '/Contratos', name: 'Contratos', props: true, component: ContratosView, meta: { pageKey: 'contratos' } },
  { path: '/inicio', name: 'Home', props: true, component: HomeView, meta: { pageKey: 'dashboard' } },
  { path: '/Finanzas', name: 'Finanzas', props: true, component: FinanzasView, meta: { pageKey: 'finanzas' } },
  { path: '/Mantenimiento', name: 'Mantenimiento', props: true, component: MantenimientoView, meta: { pageKey: 'mantenimiento' } },
  { path: '/Servicios', name: 'Servicios', props: true, component: ServiciosView, meta: { pageKey: 'servicios' } },
  { path: '/Cobranza', name: 'Cobranza', props: true, component: CobranzaView, meta: { pageKey: 'cobranza' } },
  { path: '/Configuracion', name: 'Configuracion', props: true, component: ConfiguracionView, meta: { pageKey: 'configuracion' } },
  { path: '/tecnico', name: 'TecnicoTickets', component: TechnicianTicketsView, meta: { pageKey: 'portalTecnicos' } },
  { path: '/tecnico/ticket/:id', name: 'TecnicoTicket', component: TechnicianTicketDetailView, meta: { pageKey: 'portalTecnicos' } },
  { path: '/tecnico/calendario', name: 'TecnicoCalendario', component: TechnicianCalendarView, meta: { pageKey: 'portalTecnicos' } },
  { path: '/tecnico/calendario/:id', name: 'TecnicoMantenimiento', component: TechnicianScheduledDetailView, meta: { pageKey: 'portalTecnicos' } },
  { path: '/cuenta', name: 'Cuenta', component: AccountView },
  // Primera configuración del administrador: pantalla completa, sin menú lateral.
  { path: '/bienvenida', name: 'Onboarding', component: OnboardingView, meta: { fullscreen: true } },
  // Portal del inquilino (solo cuentas de inquilino).
  { path: '/inquilino/resumen', name: 'InquilinoResumen', component: TenantSummaryView, meta: { tenantOnly: true, title: 'Resumen' } },
  { path: '/inquilino', name: 'InquilinoContrato', component: TenantContractView, meta: { tenantOnly: true, title: 'Mi contrato' } },
  { path: '/inquilino/pagos', name: 'InquilinoPagos', component: TenantPaymentsView, meta: { tenantOnly: true, title: 'Mis pagos' } },
  { path: '/inquilino/solicitudes', name: 'InquilinoSolicitudes', component: TenantRequestsView, meta: { tenantOnly: true, title: 'Mis solicitudes', section: 'maintenanceRequests' } },
  { path: '/inquilino/solicitudes/:id', name: 'InquilinoSolicitud', component: TenantRequestDetailView, meta: { tenantOnly: true, title: 'Solicitud', section: 'maintenanceRequests' } },
  { path: '/inquilino/cuenta', name: 'InquilinoCuenta', component: TenantAccountView, meta: { tenantOnly: true, title: 'Mi cuenta' } },
  // Panel de superadministrador: sin sesión de superadmin estas rutas se ven como una página inexistente.
  { path: '/superadmin', redirect: '/superadmin/parques' },
  { path: '/superadmin/acceso', name: 'SuperadminLogin', component: SuperadminLoginView, meta: { public: true, superadmin: true } },
  { path: '/superadmin/dashboard', name: 'SuperadminDashboard', component: SuperadminDashboardView, meta: { superadmin: true, title: 'Dashboard', icon: 'mdi-view-dashboard-outline' } },
  { path: '/superadmin/parques', name: 'SuperadminParques', component: SuperadminParksView, meta: { superadmin: true, title: 'Parques' } },
  { path: '/superadmin/usuarios', name: 'SuperadminUsuarios', component: SuperadminUsersView, meta: { superadmin: true, title: 'Usuarios' } },
  { path: '/superadmin/facturacion', name: 'SuperadminFacturacion', component: SuperadminBillingView, meta: { superadmin: true, title: 'Facturación' } },
  { path: '/superadmin/bitacora', name: 'SuperadminBitacora', component: SuperadminAuditView, meta: { superadmin: true, title: 'Bitácora' } },
  { path: '/superadmin/sistema', name: 'SuperadminSistema', component: SuperadminSystemView, meta: { superadmin: true, title: 'Sistema', icon: 'mdi-heart-pulse' } },
  { path: '/:pathMatch(.*)*', name: 'NotFound', component: NotFoundView, meta: { public: true } },
]

const router = createRouter({ history: createWebHistory(process.env.BASE_URL), routes })

// Primera página a la que mandamos a un usuario autenticado que no tiene permiso
// para la página que intentó visitar (o que llega a '/').
function firstAccessiblePath(user) {
  const pageToPath = {
    dashboard: '/inicio',
    contratos: '/Contratos',
    finanzas: '/Finanzas',
    mantenimiento: '/Mantenimiento',
    servicios: '/Servicios',
    cobranza: '/Cobranza',
    configuracion: '/Configuracion',
    portalTecnicos: '/tecnico',
  }
  for (const key of PAGE_KEYS) {
    if (pageToPath[key] && userHasPageAccess(user, key)) return pageToPath[key]
  }
  // Roles sin ninguna página de trabajo solo tienen su Cuenta.
  return '/cuenta'
}

router.beforeEach(async (to) => {
  // El panel de superadmin tiene su propia sesión, independiente de la de clientes.
  if (to.meta.superadmin) {
    const { admin, initAdmin } = useSuperadminStore()
    await initAdmin()
    const isLogin = to.name === 'SuperadminLogin'
    if (!admin.user) {
      if (isLogin) return true
      // Sin sesión de superadmin la sección "no existe": misma 404 que cualquier URL inventada.
      return { name: 'NotFound', params: { pathMatch: to.path.substring(1).split('/') }, query: to.query, hash: to.hash }
    }
    if (isLogin) return { path: '/superadmin/parques' }
    return true
  }

  if (to.meta.public) return true

  const { state, initSession } = useAuthStore()
  if (!state.initialized) {
    await initSession()
  }

  if (!state.user) {
    return { path: '/login', query: { redirect: to.fullPath } }
  }

  // El administrador de un parque recién creado pasa primero por la configuración inicial.
  const onboardingPending = state.user.kind !== 'TENANT' && state.user.onboarding?.pending === true
  if (onboardingPending && to.name !== 'Onboarding') return { name: 'Onboarding' }
  if (!onboardingPending && to.name === 'Onboarding') return { path: firstAccessiblePath(state.user) }

  // El inquilino solo ve su portal; el personal del parque nunca entra al portal del inquilino.
  if (state.user.kind === 'TENANT') {
    if (!to.meta.tenantOnly) return { path: '/inquilino' }
    // Secciones que el parque puede apagar desde Configuración (p. ej. solicitudes de mantenimiento).
    if (to.meta.section && state.user.sections && state.user.sections[to.meta.section] === false) return { path: '/inquilino' }
    return true
  }
  if (to.meta.tenantOnly) {
    return { path: firstAccessiblePath(state.user) }
  }

  if (to.meta.pageKey && !userHasPageAccess(state.user, to.meta.pageKey)) {
    const fallback = firstAccessiblePath(state.user)
    if (fallback !== to.path) return { path: fallback }
  }

  return true
})

export default router